interface calculateMatchRateProps {
  hoursRecommended: number
  matchedHours: number
}

export const calculateMatchRate = ({
  hoursRecommended,
  matchedHours,
}: calculateMatchRateProps): number => {
  if (hoursRecommended === 0) {
    return null
  }

  return Math.max(Math.round((matchedHours / hoursRecommended) * 100), 0)
}
